import React from 'react';

const ActivityLog = () => {
  return <div>Activity Log - Coming Soon</div>;
};

export default ActivityLog;


